import React from "react";
// components
import { DefaultLayout } from "../components/layout/defaultLayout";
import { IndexHeroSection } from "../components/section/indexHeroSection";
import { IndexNewsSection } from "../components/section/indexNewsSection";
import { SaleSection } from "../components/section/saleSection";
import { PickupSection } from "../components/section/pickupSection";
import { BrandSection } from "../components/section/brandSection";
import { GenreSection } from "../components/section/genreSection";

const IndexPage = () => {
  return (
    <DefaultLayout pageTitle="ホーム">
      <IndexHeroSection />
      <IndexNewsSection />
      <SaleSection />
      <PickupSection />
      <BrandSection />
      <GenreSection />
    </DefaultLayout>
  );
};

export default IndexPage;
